import ActiveApplications from './ActiveApplications.page';

export default ActiveApplications;
